import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { IMaskMixin } from 'react-imask';
import { useNavigate } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { ButtonWithLoader } from '../../../components/ui/Buttons';
import { TAuthTabs } from '.';
import { IAppState } from '../../../store/rootDuck';
import { actions as authActions } from '../../../store/ducks/auth.duck';
import { useAxiosEnterPassword } from '../hooks/useAxiosEnterPassword';
import { useFormikEnterPassword } from '../hooks/useFormikEnterPassword';

export const IMaskPhoneInput = IMaskMixin(({ ...props }) => {
  return <TextField {...(props as any)} />;
});

interface IProps {
  changeAuthTab: (newTab: TAuthTabs, props?: any) => void;
  initTab?: number;
}

export const CheckInSystem: React.FC<IProps> = ({
  changeAuthTab,
  initTab = 0,
}) => {
  const intl = useIntl();
  const [tab, setTab] = useState(initTab);
   const navigate = useNavigate();
  const { authToken, checkMfa } = useSelector(
    ({ auth }: IAppState) => ({
      authToken: auth.authToken,
      checkMfa: auth.checkMfa,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  
    const { makeRequest, loading, res } = useAxiosEnterPassword();
    const formik = useFormikEnterPassword(makeRequest);
  
  useEffect(() => {
    if (!authToken && !res) return;

    if (authToken && res && checkMfa) {
      dispatch(authActions.loginSuccess(res));
      navigate('/users/buyer');
    } else if (res && !checkMfa) {
      dispatch(authActions.loginSuccess(res));
      changeAuthTab('CheckInAuthenticator');
    }
  }, [res, checkMfa, authToken, navigate, dispatch]);
  


  return (
    <div className='kt-login__body'>
      <div className='kt-login__form'>
        <div className='kt-login__title'>
          <h3>Login and password</h3>
        </div>

        <form noValidate autoComplete='off' className='kt-form' onSubmit={formik.handleSubmit}>
          <div className='form-group'>
            <TextField
              variant='outlined'
              type='email'
              label={intl.formatMessage({ id: 'EMAIL_OR_LOGIN' })}
              margin='normal'
              className='kt-width-full'
              name='email'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.email}
              helperText={formik.touched.email && formik.errors.email}
              error={Boolean(formik.touched.email && formik.errors.email)}
            />

            <TextField
              variant='outlined'
              type='password'
              margin='normal'
              label='Password'
              className='kt-width-full'
              name='password'
              autoFocus
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.password}
              helperText={formik.touched.password && formik.errors.password}
              error={Boolean(formik.touched.password && formik.errors.password)}
            />
          </div>


          <div
            style={{
              display: 'flex',
              marginTop: 50,
              alignItems: 'center',
            }}
          >
            <div style={{width: '100%'}}>
              <ButtonWithLoader style={{width: '100%'}} onPress={formik.handleSubmit} disabled={loading || (!authToken && tab === 1)} loading={loading}>
                Next
              </ButtonWithLoader>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
